module.exports = __webpack_public_path__ + "img/autobus-galland.71b350ca.png";